import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDeleteSettlement } from '@/modules/Settlements/apiHooks';
import { Avatar, Button, Typography } from '@/shared/components/atoms';
import routes from '@/shared/constant/routes';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Trash from '~/images/shared/Trash.svg';

const DeleteSettlementAction = () => {
  const { t } = useTranslation('common');
  const { closeModal } = useModal();
  const { query, replace } = useRouter();
  const [selectedAsset] = useStore((store) => store?.asset);

  /*******************API********************************************* */
  const { mutate: deleteSettlement, isLoading } = useDeleteSettlement(
    selectedAsset?.settlementLevel
  );
  const handleDeleteSettlement = () => {
    if (selectedAsset?.id && query?.id)
      deleteSettlement(
        {
          entityId: selectedAsset?.id?.toString(),
          id: query?.id?.toString(),
        },
        {
          onSuccess: () => {
            closeModal();
            replace(routes.settlements);
          },
        }
      );
  };

  return (
    <div className='mt-24 flex flex-col items-center justify-center gap-24'>
      <div className='flex w-full flex-col items-center justify-center gap-24 text-center'>
        <Avatar
          icon={<Trash />}
          size='lg'
          variant='single'
          className='bg-error-90'
        />
        <Typography variant='h3' weight='semiBold'>
          {t('delete-settlement-confirmation')}
        </Typography>
      </div>
      <div className='flex w-full items-center justify-end gap-16'>
        <Button variant='text' size='none' onClick={() => closeModal()}>
          {t('cancel')}
        </Button>
        <Button
          color='red'
          size='none'
          loading={isLoading}
          onClick={handleDeleteSettlement}
          className='!rounded-xl py-2 px-16'
        >
          {t('delete')}
        </Button>
      </div>
    </div>
  );
};

export default DeleteSettlementAction;
